import * as React from 'react';
import ForgotPageView from '../layouts/ForgotPasswordView';
import { Snackbar } from '@material-ui/core';
import { AlertTitle } from '@material-ui/lab';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';

function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export interface ForgotPageProps {
    onComponentDidMount: (userName: string, typeLink: string) => void;
    onSubmit: () => void;
    newPassword: string;
    confirmPassword: string;

    typeLink: string;

    saveNewPassword: (newpassword: string) => void;
    saveConfirmPassword: (confirmpassword: string) => void;
    errorMessage: string;
    errorBar: boolean;
    successMessage: string;
    successBar: boolean;
    handleClose: () => void;

}

class ForgotPage extends React.Component<ForgotPageProps> {
    render() {
        return (
            <div>
                <ForgotPageView
                    saveNewPassword={this.props.saveNewPassword}
                    saveConfirmPassword={this.props.saveConfirmPassword}
                    newPassword={this.props.newPassword}
                    typeLink={this.props.typeLink}
                    confirmPassword={this.props.confirmPassword}
                    onSubmit={this.props.onSubmit}
                />
                <Snackbar
                    open={this.props.errorBar}
                    autoHideDuration={1000}
                    onClose={this.props.handleClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Alert
                        severity="error"
                    >
                        <AlertTitle>Error</AlertTitle>
                        {this.props.errorMessage}
                    </Alert>
                </Snackbar>
                <Snackbar
                    open={this.props.successBar}
                    autoHideDuration={2000}
                    onClose={this.props.handleClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Alert
                        severity="success"
                    >
                        <AlertTitle>Success</AlertTitle>
                        {this.props.successMessage}
                    </Alert>
                </Snackbar>
            </div>
        );
    }
    componentWillMount() {
        // const url: string = window.location.href;
        const urlParams: URLSearchParams = new URLSearchParams(window.location.search);
        const userName: string = urlParams.get('sessionId') || '';
        const typeLink: string = urlParams.get('type') || '';
        this.props.onComponentDidMount(userName, typeLink);
    }
}

export default ForgotPage;



// WEBPACK FOOTER //
// ./src/components/forgotPasswordPage/ForgotPage.tsx